"use client";
import { formatSurcharge } from "@/utils/formatSurcharge";
import { Tooltip } from "@clover-web-lib-sprout/tooltip";

export const Surcharge = ({
  isTimeSlot,
  surchargeRate,
  placement = "bottom",
}: any) => {
  const paddingRight = isTimeSlot ? "pr-5" : "";
  const surchargeRoundRate = formatSurcharge(surchargeRate);
  const surchargeText = `${surchargeRoundRate}% surcharge on credit card transactions`;
  const tooltipText = `Payments made with a credit card will incur a ${surchargeRoundRate}% surcharge fee. All
      other payment types will not incur additional fees.`;

  return (
    <Tooltip
      zindexContentClassName={"z-50"}
      content={tooltipText}
      label="surcharge-tooltip"
      placement={placement}
      shouldNotWrap
      id={"surcharge-tooltip"}
    >
      <div
        className="relative cursor-pointer h-[22.5px]"
        role="button"
        aria-label="toolTip"
        tabIndex={0}
      >
        <label
          className={`text-[14px] font-medium text-black px-1 mb-2 cursor-pointer underline decoration-dashed ${paddingRight}`}
        >
          {surchargeText}
        </label>
      </div>
    </Tooltip>
  );
};
